import { Box, styled } from "@mui/material";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { BigotinSvg } from "~/assets/svg";
import { SignInForm } from "~/components/auth/sign-in-form";

const Container = styled(Box)(({ theme }) => ({
  // TODO: replace colors with theme values
  background: "linear-gradient(204deg, #4F6EF9 17.9%, #2848FB 87.14%)",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(2),
}));

const BackgroundSvg = styled(BigotinSvg)({
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 920,
  pointerEvents: "none",
});

export const Route = createFileRoute("/signup")({
  component: SignupPage,
  beforeLoad: ({ context }) => {
    if (context.authState.isLoadingAuth) return;

    if (context.authState.isAuthenticated) {
      throw redirect({ to: "/" });
    }
  },
});

function SignupPage() {
  return (
    <Container>
      <BackgroundSvg />
      <SignInForm mode="signup" />
    </Container>
  );
}
